import React from "react";
import { css, cx } from "styled-system/css";
import type { SystemStyleObject } from "styled-system/types";
import { input } from "./input.styles";

interface InputProps extends Omit<
  React.InputHTMLAttributes<HTMLInputElement | HTMLTextAreaElement>,
  "size"
> {
  as?: "input" | "textarea";
  inputSize?: "small" | "medium";
  variant?: "default" | "ghost";
  error?: boolean;
  className?: string;
  css?: SystemStyleObject;
}

export const Input = React.forwardRef<HTMLInputElement | HTMLTextAreaElement, InputProps>(
  (
    {
      as: Component = "input",
      inputSize: sizeProp = "medium",
      variant: variantProp = "default",
      error: hasError = false,
      className: classNameProp,
      css: cssProp,
      ...props
    },
    ref,
  ) => {
    const generatedClassName = cx(
      input({ inputSize: sizeProp, variant: variantProp, error: hasError, textarea: Component === "textarea" }),
      cssProp && css(cssProp),
    );

    const classes = classNameProp ? `${generatedClassName} ${classNameProp}` : generatedClassName;

    return <Component ref={ref as any} className={classes} {...props} />;
  },
);

Input.displayName = "Input";
